var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',{attrs:{"header":!_vm.isLoading && _vm.logged},on:{"logout":_vm.logout}},[(_vm.isLoading)?_c('Loading'):(!_vm.logged)?_c('Login',{on:{"logged":_vm.setLogged}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }